import React from "react";
import styled, { css } from "styled-components";

const StyledTable = styled.table`
	position: relative;
	margin: ${(props) => props.margin};
	border-radius: 10px;
	border-collapse: seperate;
	border-spacing: 0 10px;
	width: ${(props) => props.width};
	font-family: ${(props) => props.fontFamily};
	@media (max-width: 1000px) {
		width: ${(props) => props.widthBefore1000};
	}
`;

const TableBody = styled.tbody`
	width: 100%;
	overflow-y: auto;
	height: 100%;
`;

const Tablehead = styled.th`
	font-size: ${(props) => props.fontSize};
	font-weight: 600;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	text-align: ${(props) => props.textAlign};
	padding: ${(props) => props.padding};
	border-radius: ${(props) => props.borderRadius};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	@media (max-width: 800px) {
		letter-spacing: 0;
		font-size: 1rem;
	}
	@media(max-width:1300px) {
		padding:1rem 0.5rem;
		font-size:13px;
	}
`;

const Tablerow = styled.tr`
	position:${(props) => (props.head ? "sticky" : "relative")};
	top:${(props) => (props.head ? props.top : "")};
	width:100%;
	background:${(props) => (props.head ? "#f2f2f2" : props.background)};
	border:${(props) => props.border};
	box-shadow:${(props) => props.boxShadow};
	transition:0.1s all ease-in-out;
	z-index:${(props) => (props.head ? 100 : "")};
	&:hover {
		${'' /* box-shadow:${(props) =>
				props.head || !props.hoverEffect
					? ""
					: "rgba(0, 0, 0, 0.24) 0px 3px 8px;"} */}
		transform:${(props) => props.head || !props.hoverEffect ? "" : "scale(1.01)"}
	}
	@media(max-width:${(props) => props.breakpoint}) {
		display:${(props) => (props.head ? "none" : "block")};
		margin:0 0 1rem 0;
		border-radius:10px;
		width:100%:
	}
	${props => props.disabled && css`
		opacity: 0.5;
		pointer-events:none;
	`};
`;

const Tablecolumn = styled.td`
	width: ${(props) => props.width};
	line-height: 25px;
	text-align: ${(props) => props.textAlign};
	border-radius: ${(props) => props.borderRadius};
	padding: ${(props) => (props.head ? "" : props.padding)};
	font-size: ${(props) => props.fontSize};
	@media (max-width: ${(props) => props.breakpoint}) {
		display: inline-block;
		text-overflow: ellipsis;
		max-width: 100%;
		width: max-content;
		text-align: left;
		padding: 1rem 1rem 1rem 50%;
		&::before {
			content: attr(title);
			left: 0;
			width: max-content;
			position: absolute;
			padding-left: 15px;
			font-size: 15px;
			font-weight: bold;
		}
	}
	@media (max-width: 1200px) {
		padding:1rem 0.5rem;
		font-size: 14px;
	}
	@media(min-width:1300px) {
		padding:1rem 0.5rem;
	}
`;

StyledTable.defaultProps = {
	fontFamily: "sans-serif",
	width: "100%",
};

Tablerow.defaultProps = {
	background: "#fff",
	hoverEffect: true,
	top: 0,
};

Tablehead.defaultProps = {
	padding: "1.5rem 2rem",
	fontSize: "1rem",
	textAlign: "center",
};

Tablecolumn.defaultProps = {
	padding: "2rem",
	fontSize: "1rem",
	width: "max-content",
	textAlign: "center",
};

export const Table = (props) => {
	return (
		<StyledTable ref={props.innerRef} {...props}>
			{props.children}
		</StyledTable>
	);
};

export const Tbody = (props) => {
	return <TableBody {...props} />;
};

export const Thead = (props) => {
	return <Tablehead {...props} />;
};

export const Trow = (props) => {
	return <Tablerow ref={props.innerRef} {...props} />;
};

export const Tcol = (props) => {
	return <Tablecolumn {...props} />;
};
